import {
  React,
  Component,
  withRouter,
} from 'imports/CommonImports';

import {ResetPassword} from 'imports/ComponentsImports';

const styles = {
  pageContainer: {
    display: 'flex',
    justifyContent: 'center',
  },
}

class ResetPasswordView extends Component {

  render() {
    return (
      <div style={styles.pageContainer}>
        <ResetPassword apiToken={this.props.match.params.token}/>
      </div>
    );
  }
}

export default withRouter(ResetPasswordView);



// WEBPACK FOOTER //
// ./src/views/common/ResetPasswordView.js